import React, { useContext, useEffect, useState, useRef } from "react";
import { AppContext } from "../../context";

import {
  imageUpload,
  addImageToList,
  userLogs,
  patLogs,
  initializeLocation,
  setVmgFlowType,
  setVmgUrl,
  setAuthorization,
  setCustomHiibVmg,
  gethiibMssg,
  setResizing,
  imageFeedbackLambda,
  getInspectionID,
  translateText,
  getKotakRecaptureCase,
  getAspectRatioClientList,
  setConstraint,
  makeRequest,
  getLumaBlurScore,
} from "../../context/utils";
import loadingGif from "../../img/loading.gif";
import allowedImg from "../../img/allowedOrange.png";
import deniedImg from "../../img/denied.png";

let FormModuleExist = false;
let logsbugs = true;
let moduleSelect = false;
let logData = {
  position: 1,
  camera_permission: "",
  gyro_permission: "",
  location_permission: "",
  desktop_view: "no",
  inspectionId: "",
};
let rotate = true;
let audioPermissions = false;
let stopCont = true;
let checkHiibData = false;
let startImageData =
  "data:image/jpeg;base64,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";
const PermissionPage = () => {
  const {
    nameTag,
    setNameTag,
    showAlert,
    config,
    setScreen,
    inspectionId,
    setAutoRotate,
    setLocation,
    setHiibCustomValue,
    token,
    clientId,
    caseId,
    setCurrentBlock,
    disabled,
    setDisabled,
    gyroPermission,
    setGyroPermission,
    cameraPermission,
    setCameraPermission,
  } = useContext(AppContext);
  const ackoLogs = useRef();
  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const [cameraWarning, setCameraWarning] = useState([]);
  const [loading, setLoading] = useState(false);
  const [permissionStep, setPermissionStep] = useState(false);
  let isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  let isAndroid = /Android/.test(navigator.userAgent);
  const opesWarning = useRef();

  if (logsbugs) {
    patLogs("Entered to Instructions page", getInspectionID(), "instruction");
    userLogs({
      position: 8,
      last_page: "instruction page",
      inspectionId: getInspectionID(),
      pos: "instruction",
    });
  }

  const sendLogData = async (data) => {
    await userLogs(data);
  };
  const initialize = async () => {
    if (Object.keys(config).includes("resolution")) {
      setResizing([true, config["resolution"]]);
    }
    Object.keys(config).includes("vmgFLowType") &&
      setVmgFlowType(config["vmgFLowType"]);
    Object.keys(config).includes("vmgUrl") && setVmgUrl(config["vmgUrl"]);
    Object.keys(config).includes("authorization") &&
      setAuthorization(config["authorization"]);
    Object.keys(config).includes("customHiibVmg") &&
      setCustomHiibVmg(config["customHiibVmg"]);
    if (
      Object.keys(config).includes("form-page") &&
      !Object.keys(config).includes("allowPortraitApp")
    ) {
      if (FormModuleExist) {
        setScreen("menuOpes");
      } else {
        setScreen("form");
      }
    } else if (
      Object.keys(config).includes("allowPortraitApp") &&
      config["allowPortraitApp"]
    ) {
      // setScreen("pMenu");
      setScreen("block");
      setCurrentBlock(config["blocks"][0]);
    } else {
      setScreen("menuOpes");
    }
    setLoading(false);
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const askPermission = () => {
    config["blocks"].map((e) => {
      if (
        e["name"] === "Video Capture" ||
        e["name"] === "New Video Capture" ||
        e["name"] === "VinOdo Video Capture" ||
        e["name"] === "Stencil Video" ||
        e["name"] === "New Image App"
      ) {
        moduleSelect = true;
        let payload = {
          inspection_id: inspectionId,
          client_id: clientId,
          region: "eu-central-1",
          env: 1,
          image: startImageData.replace(/^data:image\/jpeg;base64,/, ""),
        };

        getLumaBlurScore(payload);
      }
      if (e["name"] === "Video Recorder" && e["audioRecording"]) {
        audioPermissions = true;
      }
      if (e["name"] === "Form Module") {
        FormModuleExist = true;
      }
      if (e["name"] === "Custom Hiib Module") {
        checkHiibData = true;
      }
      if (
        (e["tag"] === "360 Image" &&
          Object.keys(config).includes("imageFeedback")) ||
        e["name"] === "New Image App"
      ) {
        imageFeedbackLambda({
          inspection_id: inspectionId,
          image: startImageData.replace(/^data:image\/jpeg;base64,/, ""),
          tag: "testing",
          type: e["type"] && e["type"] === "bike" ? "bike" : "car",
          client_id: clientId,
          region: "eu-central-1",
          env: 1,
          new_image_app: e["name"] === "New Image App" ? true : false,
        });
      }
      if (e["name"] === "ImageUpload") {
        rotate = false;
      }
    });
    //patLogs("Proceed button clicked", inspectionId);
    setPermissionStep(true);
  };

  const checkDesktopView = () => {
    if (isIos === false && isAndroid === false) {
      logData.desktop_view = "yes";
      // sendLogData(logData);
      setCameraWarning([
        ...cameraWarning,
        {
          type: "desktop",
          warning: Object.keys(config["errors"]).includes(
            "desktop_view_enabled"
          )
            ? config["errors"]["desktop_view_enabled"]
            : getTranslateText(
              "Desktop View is enabled.\nIos -> Setting > Safari > Request Desktop Website > All Websites (Turn it Off). refresh the link\nAndroid -> Chrome Setting > Site settings > Desktop site (Turn it off). Refresh the link\nAndroid -> Samsung Browser Setting > Settings > Advanced > Desktop site (Turn it off). Refresh the link\nAndroid -> Edge Browser Setting > Settings > General > Site display settings > Desktop site (Turn it off). Refresh the link"
            ),
        },
      ]);
    } else {
      askPermission();
    }
  };

  const checkGyroPermission = async () => {
    stopCont = true;
    patLogs("gyro button clicked", inspectionId);
    setGyroPermission("loading");
    if (
      Object.keys(config).includes("directModule") &&
      config["directModule"] === false
    ) {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        try {
          const permissionState = await DeviceMotionEvent.requestPermission();
          if (permissionState === "granted") {
            if (stopCont) {
              stopCont = false;
              logData.gyro_permission = "yes";
              setGyroPermission(true);
              let deviceOrientation = { alpha: 0, beta: 0, gamma: 0 };
              // Handle Device Orientation separately
              if (window.DeviceOrientationEvent) {
                window.addEventListener("deviceorientation", (event) => {
                  deviceOrientation = {
                    alpha: event.alpha,
                    beta: event.beta,
                    gamma: event.gamma,
                  };
                  updateLogs(deviceOrientation); // Update logs whenever orientation changes
                });
              }
            }
          } else if (
            permissionState === "denied" ||
            permissionState === "dismissed"
          ) {
            logData.gyro_permission = "no";
            setGyroPermission(false);
            sendLogData(logData);
            setCameraWarning([
              ...cameraWarning,
              {
                type: "gyro",
                warning:
                  config["errors"]["motion_sensor_safari"] ||
                  getTranslateText(
                    "Motion Sensor permission denied.\nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)"
                  ),
              },
              (ackoLogs.current.innerHTML = `
                      Android = ${isAndroid}, 
                      iOS = ${isIos}, 
                      Motion Sensor permission denied`),
            ]);
          }
        } catch (error) {
          ackoLogs.current.innerHTML = `
                      Android = ${isAndroid}, 
                      iOS = ${isIos}, 
                      Gyroscope API is not supported on iOS`;
          setCameraWarning([
            ...cameraWarning,
            {
              type: "gyro",
              warning:
                config["errors"]["motion_sensor_not_support_safari"] ||
                getTranslateText("Gyroscope API is not supported on iOS"),
            },
          ]);
          logData.gyro_permission = error.message;
          setGyroPermission(false);
          sendLogData(logData);
        }
      } else {
        ackoLogs.current.innerHTML = `
                      Android = ${isAndroid}, 
                      iOS = ${isIos}, 
                      Gyroscope API is not supported on iOS`;
        logData.gyro_permission = "Gyroscope API is not supported on iOS";
        setGyroPermission(false);
        sendLogData(logData);
        setCameraWarning([
          ...cameraWarning,
          {
            type: "gyro",
            warning:
              config["errors"]["motion_sensor_not_support_safari"] ||
              getTranslateText("Gyroscope API is not supported on iOS"),
          },
        ]);
      }
    } else if (isIos) {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        try {
          const permissionState = await DeviceMotionEvent.requestPermission();
          if (permissionState === "granted") {
            if (stopCont) {
              stopCont = false;
              logData.gyro_permission = "yes";
              setGyroPermission(true);
              //sendLogData(logData);
            }
          } else if (permissionState === "denied") {
            logData.gyro_permission = "no";
            setGyroPermission(false);
            sendLogData(logData);
            setCameraWarning([
              ...cameraWarning,
              {
                type: "gyro",
                warning: Object.keys(config["errors"]).includes(
                  "motion_sensor_safari"
                )
                  ? config["errors"]["motion_sensor_safari"]
                  : getTranslateText(
                    "Motion Sensor permission denied.\nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)"
                  ),
              },
            ]);
          } else if (permissionState === "dismissed") {
            logData.gyro_permission = "no";
            setGyroPermission(false);
            sendLogData(logData);
            setCameraWarning([
              ...cameraWarning,
              {
                type: "gyro",
                warning: Object.keys(config["errors"]).includes(
                  "motion_sensor_safari"
                )
                  ? config["errors"]["motion_sensor_safari"]
                  : getTranslateText(
                    "Motion Sensor permission denied.\nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)"
                  ),
              },
            ]);
          }
        } catch (error) {
          setCameraWarning([
            ...cameraWarning,
            {
              type: "gyro",
              warning: Object.keys(config["errors"]).includes(
                "motion_sensor_not_support_safari"
              )
                ? config["errors"]["motion_sensor_not_support_safari"]
                : getTranslateText("Gyroscope API is not supported on iOS"),
            },
          ]);
          logData.gyro_permission = error.message;
          setGyroPermission(false);
          sendLogData(logData);
        }
      } else {
        logData.gyro_permission = "Gyroscope API is not supported on iOS";
        setGyroPermission(false);
        sendLogData(logData);
        setCameraWarning([
          ...cameraWarning,
          {
            type: "gyro",
            warning: Object.keys(config["errors"]).includes(
              "motion_sensor_not_support_safari"
            )
              ? config["errors"]["motion_sensor_not_support_safari"]
              : getTranslateText("Gyroscope API is not supported on iOS"),
          },
        ]);
      }
    } else if (isAndroid && navigator.userAgent.includes("Samsung")) {
      try {
        if (window.DeviceOrientationEvent) {
          window.addEventListener("deviceorientation", (event) => {
            if (
              (event.alpha === null, event.beta === null, event.gamma === null)
            ) {
              setCameraWarning([
                ...cameraWarning,
                {
                  type: "gyro",
                  warning: Object.keys(config["errors"]).includes(
                    "motion_sensor_samsung"
                  )
                    ? config["errors"]["motion_sensor_samsung"]
                    : getTranslateText(
                      "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Sites and Downloads > Site permissions > Motion sensor > Switch it on"
                    ),
                },
              ]);
              if (stopCont) {
                logData.gyro_permission = "no";
                setGyroPermission(false);
                sendLogData(logData);
                stopCont = false;
              }
            } else {
              if (stopCont) {
                logData.gyro_permission = "yes";
                setGyroPermission(true);
                //sendLogData(logData);
                stopCont = false;
              }
            }
          });
        } else {
          setCameraWarning([
            ...cameraWarning,
            {
              type: "gyro",
              warning: Object.keys(config["errors"]).includes(
                "motion_sensor_not_support_samsung"
              )
                ? config["errors"]["motion_sensor_not_support_samsung"]
                : getTranslateText(
                  "DeviceOrientationEvent (gyro) not supported in this browser."
                ),
            },
          ]);
          logData.gyro_permission = "no";
          setGyroPermission(false);
          sendLogData(logData);
        }
      } catch (error) {
        logData.gyro_permission = "no";
        setGyroPermission(false);
        sendLogData(logData);
        setCameraWarning([
          ...cameraWarning,
          {
            type: "gyro",
            warning: Object.keys(config["errors"]).includes(
              "motion_sensor_samsung"
            )
              ? config["errors"]["motion_sensor_samsung"]
              : getTranslateText(
                "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Sites and Downloads > Site permissions > Motion sensor > Switch it on"
              ),
          },
        ]);
      }
    } else if (isAndroid && navigator.userAgent.includes("Edg")) {
      try {
        if (window.DeviceOrientationEvent) {
          window.addEventListener("deviceorientation", (event) => {
            if (
              (event.alpha === null, event.beta === null, event.gamma === null)
            ) {
              setCameraWarning([
                ...cameraWarning,
                {
                  type: "gyro",
                  warning: Object.keys(config["errors"]).includes(
                    "motion_sensor_edge"
                  )
                    ? config["errors"]["motion_sensor_edge"]
                    : getTranslateText(
                      "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Privacy and Security > Site Settings > Motion sensor > Switch it on"
                    ),
                },
              ]);
              if (stopCont) {
                logData.gyro_permission = "no";
                setGyroPermission(false);
                sendLogData(logData);
                stopCont = false;
              }
            } else {
              if (stopCont) {
                logData.gyro_permission = "yes";
                setGyroPermission(true);
                //sendLogData(logData);
                stopCont = false;
              }
            }
          });
        } else {
          setCameraWarning([
            ...cameraWarning,
            {
              type: "gyro",
              warning: Object.keys(config["errors"]).includes(
                "motion_sensor_not_support_edge"
              )
                ? config["errors"]["motion_sensor_not_support_edge"]
                : getTranslateText(
                  "DeviceOrientationEvent (gyro) not supported in this browser."
                ),
            },
          ]);
          logData.gyro_permission = "no";
          setGyroPermission(false);
          sendLogData(logData);
        }
      } catch (error) {
        logData.gyro_permission = "no";
        setGyroPermission(false);
        sendLogData(logData);
        setCameraWarning([
          ...cameraWarning,
          {
            type: "gyro",
            warning: Object.keys(config["errors"]).includes(
              "motion_sensor_edge"
            )
              ? config["errors"]["motion_sensor_edge"]
              : getTranslateText(
                "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Privacy and Security > Site Settings > Motion sensor > Switch it on"
              ),
          },
        ]);
      }
    } else if (isAndroid) {
      try {
        if (window.DeviceOrientationEvent) {
          window.addEventListener("deviceorientation", (event) => {
            if (
              (event.alpha === null, event.beta === null, event.gamma === null)
            ) {
              setCameraWarning([
                ...cameraWarning,
                {
                  type: "gyro",
                  warning: Object.keys(config["errors"]).includes(
                    "motion_sensor_chrome"
                  )
                    ? config["errors"]["motion_sensor_chrome"]
                    : getTranslateText(
                      "Gyro permission is denied \nAt right top corner, click on three dots of chrome > settings > site settings > motion sensor > switch it on"
                    ),
                },
              ]);
              if (stopCont) {
                logData.gyro_permission = "no";
                setGyroPermission(false);
                sendLogData(logData);
                stopCont = false;
              }
            } else {
              if (stopCont) {
                logData.gyro_permission = "yes";
                setGyroPermission(true);
                //sendLogData(logData);
                stopCont = false;
              }
            }
          });
        } else {
          setCameraWarning([
            ...cameraWarning,
            {
              type: "gyro",
              warning: Object.keys(config["errors"]).includes(
                "motion_sensor_not_support_chrome"
              )
                ? config["errors"]["motion_sensor_not_support_chrome"]
                : getTranslateText(
                  "DeviceOrientationEvent (gyro) not supported in this browser."
                ),
            },
          ]);
          logData.gyro_permission = "no";
          setGyroPermission(false);
          sendLogData(logData);
        }
      } catch (error) {
        logData.gyro_permission = "no";
        setGyroPermission(false);
        sendLogData(logData);
        setCameraWarning([
          ...cameraWarning,
          {
            type: "gyro",
            warning: Object.keys(config["errors"]).includes(
              "motion_sensor_chrome"
            )
              ? config["errors"]["motion_sensor_chrome"]
              : getTranslateText(
                "Gyro permission is denied \nAt right top corner, click on three dots of chrome > settings > site settings > motion sensor > switch it on"
              ),
          },
        ]);
      }
    }
  };

  const checkCameraPermission = async () => {
    patLogs("camera allow button clicked", inspectionId);
    setCameraPermission("loading");
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: audioPermissions,
      });
      mediaStream.getTracks().forEach((track) => {
        track.stop();
      });
      logData.camera_permission = "yes";
      setCameraPermission(true);
      //sendLogData(logData);
    } catch (error) {
      logData.camera_permission = "no";
      setCameraPermission(false);
      sendLogData(logData);
      if (isIos) {
        setCameraWarning([
          ...cameraWarning,
          {
            type: "camera",
            warning: Object.keys(config["errors"]).includes("camera_error_ios")
              ? config["errors"]["camera_error_ios"]
              : getTranslateText(
                "Camera is already in use by another application or tab. or blocked \nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)"
              ),
          },
        ]);
      } else if (isAndroid && navigator.userAgent.includes("Samsung")) {
        setCameraWarning([
          ...cameraWarning,
          {
            type: "camera",
            warning: Object.keys(config["errors"]).includes(
              "camera_error_samsung"
            )
              ? config["errors"]["camera_error_samsung"]
              : getTranslateText(
                "Camera is already in use by another application or tab. or blocked \nAt bottom right corner, click on three horizontal lines of Samsung menu > Sites and Downloads > Site Permission > Camera > switch it on \n blocked > https://superapp.inspektlabs.com > Allow. \n (Refresh the link and allow all Permission)"
              ),
          },
        ]);
      } else if (isAndroid && navigator.userAgent.includes("Edg")) {
        setCameraWarning([
          ...cameraWarning,
          {
            type: "camera",
            warning: Object.keys(config["errors"]).includes("camera_error_edge")
              ? config["errors"]["camera_error_edge"]
              : getTranslateText(
                "Camera is already in use by another application or tab. or blocked \nAt bottom right corner, click on three horizontal lines > Settings > Privacy and Security > Site Settings > Camera > switch it on \n blocked > https://superapp.inspektlabs.com > Allow. \n (Refresh the link and allow all Permission)"
              ),
          },
        ]);
      } else if (isAndroid) {
        setCameraWarning([
          ...cameraWarning,
          {
            type: "camera",
            warning: Object.keys(config["errors"]).includes(
              "camera_error_android"
            )
              ? config["errors"]["camera_error_android"]
              : getTranslateText(
                "Camera is already in use by another application or tab. or blocked \nAt right top corner, click on three dots of chrome > settings > site settings > camera > switch it on \n blocked > https://superapp.inspektlabs.com > Allow. \n (Refresh the link and allow all Permission)"
              ),
          },
        ]);
      }
    }
  };

  useEffect(() => {
    checkDesktopView();
    config["blocks"].forEach((e) => {
      if (e.values.length > 0) {
        e.values.forEach((a) => {
          setNameTag((prev) => ({
            ...prev,
            [`${e.tag}: ${a.tag}`]: `${e.id}: ${a.name}`,
          }));
        });
      } else {
        setNameTag((prev) => ({
          ...prev,
          [e.tag]: e.id,
        }));
      }
    });
    // console.log(nameTag);
  }, []);

  useEffect(() => {
    logData.inspectionId = getInspectionID();
    if (moduleSelect === false && cameraPermission === true) {
      setDisabled(false);
      initialize();
    } else if (gyroPermission === true && cameraPermission === true) {
      setDisabled(false);
      initialize();
    }
    if (cameraWarning === false || gyroPermission === false) {
      opesWarning.current.style.display = "flex";
    }
  }, [gyroPermission, cameraPermission, setCameraWarning, cameraWarning]);

  return (
    <div>
      <div
        className="permissionCss"
        style={{ flexDirection: "column", width: "100%", position: "relative" }}
      >
        {/* <div className="opesWarning" ref={opesWarning}>
          {cameraWarning.map((e, index) => (
            <p key={index}>{e.warning}</p>
          ))}
          <div className="opesDiv">
            <button
              style={{ backgroundColor: config["colors"]["btn"] }}
              onclick={() => {
                opesWarning.current.style.display = "none";
              }}
            >
              Continue
            </button>
          </div>
        </div> */}
        <div className="permissionCss" style={{ width: "100%" }}>
          <div className="permissionCssdiv" style={{ width: "100%" }}>
            <h4 style={{ fontSize: "14px" }}>
              {Object.keys(config["errors"]).includes("cameraHeaderText")
                ? config["errors"]["cameraHeaderText"]
                : getTranslateText("Camera Permission")}
            </h4>
            <p style={{ fontSize: "12px" }}>
              {Object.keys(config["errors"]).includes("cameraRequirementText")
                ? config["errors"]["cameraRequirementText"]
                : getTranslateText("For capturing photo / video of car")}
            </p>
          </div>
          <div className="permmisionbtndiv">
            {cameraPermission === null ? (
              <button
                style={
                  config["colors"]["permissionBtn"]
                    ? {
                      background: config["colors"]["permissionBtn"],
                      color: "white",
                    }
                    : { background: config["colors"]["btn"] }
                }
                onClick={() => checkCameraPermission()}
              >
                {Object.keys(config["errors"]).includes("alowBtnText")
                  ? config["errors"]["alowBtnText"]
                  : getTranslateText("Allow")}
              </button>
            ) : cameraPermission === true ? (
              <img src={allowedImg} style={{ margin: "0px", width: "45px" }} />
            ) : cameraPermission === "loading" ? (
              <img style={{ width: "36px" }} src={loadingGif} />
            ) : (
              <img src={deniedImg} style={{ margin: "0px", width: "36px" }} />
            )}
          </div>
        </div>
      </div>
      {/* Gyro permission */}
      {moduleSelect && (
        <div
          className="permissionCss"
          style={{ flexDirection: "column", width: "100%", marginTop: "10px" }}
        >
          <div className="permissionCss" style={{ width: "100%" }}>
            <div className="permissionCssdiv" style={{ width: "100%" }}>
              <h4 style={{ fontSize: "14px" }}>
                {Object.keys(config["errors"]).includes("gyroHeaderText")
                  ? config["errors"]["gyroHeaderText"]
                  : getTranslateText("Gyro Permission")}
              </h4>
              <p style={{ fontSize: "12px" }}>
                {Object.keys(config["errors"]).includes("gyroRequirementText")
                  ? config["errors"]["gyroRequirementText"]
                  : getTranslateText("For detecting phone position WRT car")}
              </p>
            </div>
            <div className="permmisionbtndiv">
              {gyroPermission === null ? (
                <button
                  style={
                    config["colors"]["permissionBtn"]
                      ? {
                        background: config["colors"]["permissionBtn"],
                        color: "white",
                      }
                      : { background: config["colors"]["btn"] }
                  }
                  onClick={() => checkGyroPermission()}
                >
                  {Object.keys(config["errors"]).includes("alowBtnText")
                    ? config["errors"]["alowBtnText"]
                    : getTranslateText("Allow")}
                </button>
              ) : gyroPermission === true ? (
                <img
                  src={allowedImg}
                  style={{ margin: "0px", width: "45px" }}
                />
              ) : gyroPermission === "loading" ? (
                <img style={{ width: "36px" }} src={loadingGif} />
              ) : (
                <img src={deniedImg} style={{ margin: "0px", width: "36px" }} />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PermissionPage;
